/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/components';

export const ItemSubmenuIcon = () => (
	<SVG
		xmlns="http://www.w3.org/2000/svg"
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
	>
		<Path d="M1.50002 4L6.00002 8L10.5 4" strokeWidth="1.5" />
	</SVG>
);
